import * as rmd from 'material-ui';
import React from 'react';
import config from 'cfg';
import Promise from 'bluebird';
import moment from 'moment';

class DatePicker extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            date: props.date ? new Date(props.date) : new Date()
        };
    }

    componentDidMount() {
        this.handleDateChange(null, this.state.date);
    }

    handleDateChange = (key, value) => {
        var date = moment(value).local();
        var from = date.format('YYYY-MM-DD');
        this.setState({ date: value });
        this.props.onChange('date', from);
    };

    render() {
        return (
            <div>
                <rmd.DatePicker
                    hintText="Choose date"
                    floatingLabelText={this.props.label}
                    value={this.state.date}
                    container="inline"
                    autoOk
                    onChange={this.handleDateChange}
                />
            </div>
        );
    }
}

export default DatePicker;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/pickers/DatePicker.js
 **/